// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteChatContent_T7YAv {
  display: flex;
  align-items: center;
  justify-content: center;
}

.deleteChatsContainer_ozeDG {
  width: 100%;
  background-color: #fff;
  margin: 0 10px 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;

  p {
    margin: 0;
    color: #38343d;
  }

  .passwordSimple_sl7vn {
    display: flex;
    align-items: center;
    gap: 10px;

    >button {
      flex: 1 1;
    }
  }

  .password_ckOdL {
    display: flex;
    align-items: center;

    span,
    >div {
      flex: 1 1;
    }

    >div {
      input {
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 21px;
        background-color: #f4f4f4;
        border-radius: 5px;
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
      }

      span {
        color: #b40e1b;
        font-size: 13px;
      }

      .errorText_uNLM2 {
        font-size: 13px;
        color: #b40e1b;
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DeleteChatAgents/DeleteChatAgents.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;;EAEnB;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,SAAO;IACT;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB;;MAEE,SAAO;IACT;;IAEA;MACE;QACE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;QAChB,yBAAyB;QACzB,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,aAAa;MACf;;MAEA;QACE,cAAc;QACd,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,cAAc;MAChB;IACF;EACF;AACF","sourcesContent":[".deleteChatContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.deleteChatsContainer {\n  width: 100%;\n  background-color: #fff;\n  margin: 0 10px 10px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 10px;\n\n  p {\n    margin: 0;\n    color: #38343d;\n  }\n\n  .passwordSimple {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    >button {\n      flex: 1;\n    }\n  }\n\n  .password {\n    display: flex;\n    align-items: center;\n\n    span,\n    >div {\n      flex: 1;\n    }\n\n    >div {\n      input {\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 21px;\n        background-color: #f4f4f4;\n        border-radius: 5px;\n        box-sizing: border-box;\n        width: 100%;\n        padding: 12px;\n      }\n\n      span {\n        color: #b40e1b;\n        font-size: 13px;\n      }\n\n      .errorText {\n        font-size: 13px;\n        color: #b40e1b;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteChatContent": `deleteChatContent_T7YAv`,
	"deleteChatsContainer": `deleteChatsContainer_ozeDG`,
	"passwordSimple": `passwordSimple_sl7vn`,
	"password": `password_ckOdL`,
	"errorText": `errorText_uNLM2`
};
export default ___CSS_LOADER_EXPORT___;
